// Route configuration - defines which routes belong to which feature area
export const OPERATIONAL_REPORT_ROUTES = [
  "/operationalreportslandingpage",
  "/reportpage"
];

export const ADMIN_ROUTES = [
  "/taskmanagment",
  "/devicegeocompliance",
  "/outletStatus",
  "/adminconfigurationpage",
  "/useraccess",
  "/estimatedbestprice",
  "/salesmandeviceid",
  "/outletGeoCompliance",
  "/merchandizingSets",
  "/masterManagement",
  "/leaveManagement",
  "/targetMaster",
  "/perfectstorevisibilitymanagement",
  "/posmConfiguration",
  "/surveyConfiguration",
  "/sosConfiguration"
];

export const UCUBE_ROUTES = [
  "/",
  "/homepage",
  "/teamlevels",
  "/distributorteamlevels",
  "/disciplinaryteamlevels",
  "/locate",
  "/ucubehierarchymanagement"
];

export const ROUTES_WITHOUT_HEADER = ["/login", "/signup", "/forgotpassword"];
export const ADMIN_ROUTE_LABELS = {
  "/taskmanagment": "Task Management",
  "/devicegeocompliance": "Device Geo-Compliance",
  "/outletStatus": "Outlet Status - Online / Offline",
  "/useraccess": "User Access Management",
  "/estimatedbestprice": "Estimated Best Price",
  "/salesmandeviceid": "Salesman Device ID Update",
  "/outletGeoCompliance": "Outlet Geo-Compliance",
  "/merchandizingSets": "Merchandizing Sets",
  "/masterManagement": "Image as Data - Master Management",
  "/leaveManagement": "Leave Management",
  "/targetMaster": "Target Master",
  "/perfectstorevisibilitymanagement": "Perfect Store - Visibility Data Management",
  "/posmConfiguration": "POSM Configuration",
  "/surveyConfiguration": "Survey Configuration",
  "/sosConfiguration": "SOS Configuration",
};